var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 429,
    viewBox: "0 0 378 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.994 4.65125C183.658 -0.350466 194.331 -0.350454 202.994 4.65126L363.783 97.4827C372.446 102.484 377.783 111.728 377.783 121.731V307.394C377.783 317.398 372.446 326.641 363.783 331.643L202.994 424.474C194.331 429.476 183.658 429.476 174.994 424.474L14.2057 331.643C5.54248 326.641 0.205719 317.398 0.205719 307.394V121.731C0.205719 111.728 5.54249 102.484 14.2057 97.4827L174.994 4.65125Z",
    fill: "url(#paint0_linear_1734_41)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1734_41",
    x1: 188.994,
    y1: -3.43164,
    x2: 188.994,
    y2: 432.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00265F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.69b7bb1813c01351b21c6e4e5f0b8bdc.svg";
export { ForwardRef as ReactComponent };